import auth from "@/middleware/auth";
import admin from "@/middleware/admin";

export const regionRoutes = [
  {
    path: "/directories/region",
    name: "RegionList",
    meta: { middleware: [auth, admin] },
    component: () =>
      import(/* webpackChunkName: "region" */ "./components/List"),
  },
];
